<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>

    <div class="p-6 pb-0">
      <div class="mb-4 bg-white rounded-lg shadow-sm border border-gray-100 p-4 flex flex-wrap gap-6 text-sm">
        <div>
          <span class="text-gray-400 uppercase text-xs font-semibold tracking-wide">Ordine</span>
          <div class="font-bold text-lg text-gray-800 mt-0.5">{{ ordine }}</div>
        </div>
        <div v-if="ordineInfo">
          <span class="text-gray-400 uppercase text-xs font-semibold tracking-wide">Cliente</span>
          <div class="font-medium text-gray-800 mt-0.5">{{ ordineInfo.companyname }}</div>
          <div class="text-xs text-gray-400">{{ ordineInfo.Customer }}</div>
        </div>
        <div v-if="ordineInfo">
          <span class="text-gray-400 uppercase text-xs font-semibold tracking-wide">Città</span>
          <div class="font-medium text-gray-800 mt-0.5">{{ ordineInfo.city }} {{ ordineInfo.ZIPCode }}</div>
        </div>
        <div v-if="ordineInfo">
          <span class="text-gray-400 uppercase text-xs font-semibold tracking-wide">Settimana cons.</span>
          <div class="font-medium text-gray-800 mt-0.5">Sett. {{ ordineInfo.settcons }} / {{ ordineInfo.Annocons }}</div>
        </div>
        <div v-if="ordineInfo && (ordineInfo.memo || ordineInfo.NoteSede)" class="flex-1 min-w-0">
          <span class="text-gray-400 uppercase text-xs font-semibold tracking-wide">Note</span>
          <div class="text-gray-600 mt-0.5 truncate" :title="ordineInfo.memo || ordineInfo.NoteSede">
            {{ ordineInfo.memo || ordineInfo.NoteSede }}
          </div>
        </div>
        <div v-if="ordineInfo && ordineInfo.Autorizzato === 'No'" class="flex items-end">
          <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
            Bloccato
          </span>
        </div>
      </div>

      <PageServerTable
        :headers="headers"
        :items="righe"
        :items-per-page="righe.length || 25"
        :items-per-page-options="[{ value: -1, title: 'Tutti' }]"
        :sort-by="[]"
        :items-length="righe.length"
        :reload-fn="() => {}"
        hide-default-footer
      >
        <template #item.Prelevato="{ item }">
          <span
            :class="dotClass(item.Prelevato === 'Si' ? 2 : 0)"
            class="inline-block w-3 h-3 rounded-full"
            :title="item.Prelevato === 'Si' ? 'Prelevato' : 'Da prelevare'"
          />
        </template>

        <template #item.ProdottoAT="{ item }">
          <span
            :class="item.ProdottoAT === 'Si' ? 'bg-orange-400' : 'bg-gray-200'"
            class="inline-block w-3 h-3 rounded-full"
            :title="item.ProdottoAT === 'Si' ? 'Prodotto a terzista' : 'Produzione interna'"
          />
        </template>

        <template #item.Imballato="{ item }">
          <span
            :class="dotClass(item.Imballato === 'Si' ? 2 : 0)"
            class="inline-block w-3 h-3 rounded-full"
            :title="item.Imballato === 'Si' ? 'Imballato' : 'Non imballato'"
          />
        </template>
      </PageServerTable>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Layout from '@/Layouts/Layout.vue';
import PageServerTable from '@/Components/PageServerTable.vue';

export default {
  components: {
    BreadCrumbs,
    Layout,
    PageServerTable,
    Link,
  },
  props: ['user', 'moduleSlug', 'ordine', 'ordineInfo', 'righe', 'headers'],
  computed: {
    navigation() {
      return [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.' + this.moduleSlug), href: route('modules.home', this.moduleSlug) },
        { name: this.ordine, href: route('modules.pannello-di-controllo.ordine', { ordine: this.ordine }) },
      ];
    },
  },
  methods: {
    dotClass(stato) {
      if (stato === 2) return 'bg-green-500';
      if (stato === 1) return 'bg-yellow-400';
      return 'bg-red-500';
    },
  },
};
</script>
